import React, { Component } from "react";

class Empty extends Component {
  checkType(type) {
    switch (type) {
      case "shop":
        return "Stores";
      case "product":
        return "Products";
      case "customer":
        return "Customer";
      case "cart":
        return "Shopping";
      case "comment":
        return "Comment";
      default:
        return "01";
    }
  }
  render() {
    return (
      <div className="col text-center">
        <img
          alt=""
          width="50%"
          src={
            require(`../../assets/images/${this.checkType(
              this.props.type
            )}.svg`).default
          }
        />
        <p className="mt-2">
          {this.props.text ? this.props.text : "موردی یافت نشد."}
        </p>
      </div>
    );
  }
}

export default Empty;
